(() => {
  const messages = {
    confirmed:'Ürününüzün hologram kodu doğrulandı. İlk doğrulama kaydı oluşturuldu.',
    before:'Bu kod daha önce doğrulanmış. Daha önce siz sorgulamadıysanız ambalajınızla birlikte ekibimize ulaşın.',
    notfound:'Bu kod kayıtlarımızda bulunamadı. Hologramdaki kodu kontrol edin; sorun devam ederse ekibimize ulaşın.',
    error:'Doğrulama şu anda tamamlanamadı. Lütfen daha sonra tekrar deneyin.',
    limited:'Çok fazla deneme yapıldı. Bir süre bekleyip tekrar deneyin.'
  };
  function setup(scope = document) {
    scope.querySelectorAll('[data-hologram-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      let pending = false, lastAttempt = 0;
      const result = form.querySelector('[data-hologram-result]');
      const button = form.querySelector('button[type=submit]');
      function show(status) { result.hidden = false; result.dataset.status = status; result.textContent = messages[status] || messages.error; }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        if (Date.now() - lastAttempt < 5000) return show('limited');
        const fields = new FormData(form);
        const phone = String(fields.get('phone')).replace(/\D/g,'');
        if (!/^(?:90|0)?5\d{9}$/.test(phone)) {
          result.hidden = false; result.textContent = 'Telefon numaranızı 05XX XXX XX XX biçiminde kontrol edin.'; return;
        }
        pending = true; lastAttempt = Date.now(); button.disabled = true;
        button.textContent = 'Sorgulanıyor…'; form.setAttribute('aria-busy','true'); result.hidden = true;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(),15000);
        try {
          const response = await fetch('https://api.stormvitals.com.tr/api/hologram/verify',{
            method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',signal:controller.signal,
            body:JSON.stringify({code:String(fields.get('code')).trim().toUpperCase(),name:String(fields.get('name')).trim(),phone})
          });
          if (response.status === 429) return show('limited');
          if (!response.ok) throw new Error('Verification unavailable');
          const data = await response.json();
          // Never expose a previous customer's name returned by the legacy endpoint.
          show(Object.hasOwn(messages,data.status) ? data.status : 'error');
          if (data.status === 'confirmed') form.reset();
        } catch { show('error'); }
        finally { clearTimeout(timer); pending = false; button.disabled = false; button.textContent = 'Ürünümü doğrula'; form.removeAttribute('aria-busy'); }
      });
    });
  }
  setup(); document.addEventListener('shopify:section:load', event => setup(event.target));
})();
